import React from "react";

/**
 * OPTIMIZED VideoThumbnail component
 * Simply displays the server-provided thumbnail without expensive client-side generation
 * Server thumbnails are generated by AWS Lambda during video transcoding
 */
const VideoThumbnail = ({
  videoUrl,
  thumbnailUrl,
  alt,
  className,
  onError,
}) => {
  // Use the server-provided thumbnail directly
  // No need for client-side generation - it's already done server-side
  return (
    <img
      src={thumbnailUrl}
      alt={alt}
      className={className}
      onError={onError}
      loading="lazy"
    />
  );
};

export default VideoThumbnail;
